import React, { Component, Fragment } from "react";
import { PaginationLink, Pagination, PaginationItem } from "reactstrap";
import "../../assets/scss/plugins/extensions/react-paginate.scss";
import { ChevronLeft, ChevronRight } from "react-feather"
import IPaginator, { IPaginatorQueryType } from "../../types/Paginator";

interface IPaginatorCompProps {
    paginator: IPaginator,
    onPrev: (pageNo:number) => void,
    onNext: (pageNo:number) => void,
    goToPage: (pageNo:number)=> void
}

interface IPaginatorCompState {

}

export default class PaginatorComp extends Component<IPaginatorCompProps, IPaginatorCompState> {

    render() {
        const {paginator, onNext, onPrev, goToPage} = this.props;
        const { totalPages, pageNumber, type, prevCursor, nextCursor} = paginator;
        const isPrevEnabled = type == IPaginatorQueryType.Elastic ?  pageNumber != 0 : prevCursor != null;
        const isNextEnabled = type == IPaginatorQueryType.Elastic ? (totalPages - 1 > pageNumber) : nextCursor != null;

        const showArrows = type == IPaginatorQueryType.Elastic ? (totalPages > 0) : true;
        
        const leftArrow = showArrows ? <PaginationItem className="prev-item" disabled={!isPrevEnabled}>
                            <PaginationLink onClick={()=> 
                                {
                                    if(isPrevEnabled)
                                        onPrev(pageNumber - 1)
                                }} first>
                                <ChevronLeft />
                            </PaginationLink>
                        </PaginationItem> : null;
        let pillArr = [];
        if(totalPages > 10){
            for(let i=pageNumber;i<pageNumber+5;i++){
                pillArr.push(i);
            }
            pillArr.push(-1);
            for(let i=totalPages-5;i<totalPages;i++){
                pillArr.push(i);
            }
        } else {
            pillArr = Array.from(Array(totalPages).keys())
        }
        
        const pills = pillArr.map((n:number, i:number)=> {
            return <PaginationItem active={i == pageNumber} onClick={()=>{n !== -1 ? goToPage(n) : null}} key={i}>
                <PaginationLink href="#">{n == -1 ? '...' : n}</PaginationLink>
            </PaginationItem>
        })

        const rightArrow = showArrows ? <PaginationItem  className="next-item" disabled={!isNextEnabled}>
                                <PaginationLink onClick={()=> 
                                    {
                                        if(isNextEnabled)
                                            onNext(pageNumber + 1)
                                    }} last>
                                    <ChevronRight />
                                </PaginationLink>
                            </PaginationItem> : null;
        return <div className="text-center">
                <div className="_library-pagination">
                    <Pagination className="d-flex justify-content-center mt-2">
                        { leftArrow }
                        
                        { pills }
                        
                        { rightArrow }
                    </Pagination>
                </div>
        </div>
    }
}